import { render } from "./step-owners.vue?vue&type=template&id=5c324b92"
import script from "./step-owners.vue?vue&type=script&lang=js"
export * from "./step-owners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__